export const AGENCY = {
  name: 'IVORY Home Health Care',
  address: '3605 Long Beach Blvd., Ste 331',
  cityStateZip: 'Long Beach, CA 90807',
  phone: '(562) 349-0860',
  fax: '(562) 285-7216',
  email: 'info@ivoryhh.com',
};

export const AGENCY_CONTACT_LINE = `Ph: ${AGENCY.phone}  |  Fax: ${AGENCY.fax}  |  ${AGENCY.email}`;
export const AGENCY_PROVIDER_BLOCK = `${AGENCY.name}\n${AGENCY.address}, ${AGENCY.cityStateZip}\nPh: ${AGENCY.phone}  Fax: ${AGENCY.fax}`;

let logoDataUrl = null;

export const loadAgencyLogo = async () => {
  if (logoDataUrl) return logoDataUrl;
  try {
    const blob = await (await fetch('/images/ivory-logo.png')).blob();
    logoDataUrl = await new Promise((resolve) => {
      const r = new FileReader();
      r.onload = () => resolve(r.result);
      r.readAsDataURL(blob);
    });
  } catch {
    logoDataUrl = null;
  }
  return logoDataUrl;
};

// Logo + agency name/address/phone block; returns bottom y. light=true for dark backgrounds
export const drawAgencyHeader = (doc, x, y, opts = {}) => {
  const auto = doc.autoFill;
  doc.autoFill = false;
  const out = drawAgencyHeaderInner(doc, x, y, opts);
  doc.autoFill = auto;
  return out;
};

// Page-1 header in the agency style: logo, name, address, contact line and a blue rule
export const drawTitledHeader = (doc, title) => {
  const W = doc.internal.pageSize.getWidth();
  drawAgencyHeader(doc, 15, 5, { size: 15 });
  doc.setFont('helvetica', 'bold'); doc.setFontSize(13); doc.setTextColor(30, 58, 138);
  doc.text(title, W / 2, 32, { align: 'center' });
  doc.setTextColor(0);
};

const drawAgencyHeaderInner = (doc, x, y, { size = 14, light = false, align = 'left', rule = !light } = {}) => {
  const pageW = doc.internal.pageSize.getWidth();
  const textX = align === 'right' ? pageW - x : x + (logoDataUrl ? size + 3 : 0);
  if (logoDataUrl) {
    const lx = align === 'right' ? pageW - x - size - 3 - doc.getTextWidth(AGENCY_CONTACT_LINE) : x;
    if (align !== 'right') doc.addImage(logoDataUrl, 'PNG', lx, y, size, size);
  }
  const color = light ? [255, 255, 255] : [20, 20, 20];
  const opts = align === 'right' ? { align: 'right' } : undefined;
  doc.setTextColor(...color);
  doc.setFont('helvetica', 'bold'); doc.setFontSize(10);
  doc.text(AGENCY.name.toUpperCase(), textX, y + 4, opts);
  doc.setFont('helvetica', 'normal'); doc.setFontSize(7.5);
  doc.text(`${AGENCY.address}, ${AGENCY.cityStateZip}`, textX, y + 8, opts);
  doc.text(AGENCY_CONTACT_LINE, textX, y + 11.5, opts);
  if (rule) { doc.setDrawColor(30, 64, 175); doc.setLineWidth(0.6); doc.line(x, y + size + 1.2, pageW - x, y + size + 1.2); doc.setLineWidth(0.2); }
  return y + size;
};

// preload so every PDF builder (including the older form exporters) can draw the logo
if (typeof window !== 'undefined') loadAgencyLogo();
